import { WebGLRenderer } from "three";
import settings from "./settings";

const renderer = new WebGLRenderer({
  antialias: true,
  powerPreference: "high-performance",
  stencil: false,
});
// Enable shader errors during dev
renderer.debug.checkShaderErrors = settings.isDevelopment;

renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
renderer.setClearColor(0xffffff, 1);
renderer.setScissorTest(true);

export function toggleCursor(showPointer) {
  if (showPointer) {
    renderer.domElement.classList.add("hover");
  } else {
    renderer.domElement.classList.remove("hover");
  }
}

export default renderer;
